const inputInvalidIntegerMessage = "Invalid format for filter value. This filter only supports integer values";
const inputInvalidStringValueMessage = "Value for this filter type can contain only alphabetical characters [a-z] and [A-Z], numbers 0-9, hyphens -, underscores _ and periods.";
const inputInvalidLongStringValueMessage = (maxLength) => `Value for this filter type can not be longer than ${maxLength} characters.`;
const inputInvalidVersionValueMessage = (filterDisplayName) => `Invalid format for ${filterDisplayName}. Must be of the form x.x.x or x.x.x.x, where x are numbers.`;
const inputInvalidRangeMissingValueMessage = (filterDisplayName) => `${filterDisplayName}: 'Between' filters must have an upper and lower bound.`;
const inputInvalidBetweenRangeValueMessage = (filterDisplayName) => `${filterDisplayName}: 'Between' filter To value must be greater than From value.`;
const inputInvalidOrRangeValueMessage = (filterDisplayName) => `${filterDisplayName}: 'Or' filter value ranges overlap.`;
const inputInvalidRangeMultipleValueMessage = "Range operator (>, >=, <, <=) should only specify one value";
export {
  inputInvalidBetweenRangeValueMessage,
  inputInvalidIntegerMessage,
  inputInvalidLongStringValueMessage,
  inputInvalidOrRangeValueMessage,
  inputInvalidRangeMissingValueMessage,
  inputInvalidRangeMultipleValueMessage,
  inputInvalidStringValueMessage,
  inputInvalidVersionValueMessage
};
//# sourceMappingURL=AudienceFilterValidation.constants.js.map
